// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --clr-neon: hsl(46, 100%, 50%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.neon-button {
  font-size: 20px;
  background-color: transparent;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  color: var(--clr-neon);
  border: var(--clr-neon) 0.125em solid;
  padding: 0.25em 1em;
  border-radius: 0.25em;
  text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;
  box-shadow: inset 0 0 0.5em 0 var(--clr-neon), 0 0 0.5em 0 var(--clr-neon);
  position: relative;
  margin: 10px;
  height: 50px;
}

.neon-button::before {
  pointer-events: none;
  content: '';
  position: absolute;
  background: var(--clr-neon);
  top: 120%;
  left: 0;
  width: 100%;
  height: 100%;
  transform: perspective(1em) rotateX(40deg) scale(1, 0.35);
  filter: blur(1em);
  opacity: 0.7;
}

.neon-button::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0 0 2em 0.5em var(--clr-neon);
  opacity: 0;
  background-color: var(--clr-neon);
  z-index: -1;
  transition: opacity 100ms linear;
}

.neon-button:hover,
.neon-button:focus {
  color: var(--clr-bg);
  text-shadow: none;
}

.neon-button:hover::before,
.neon-button:focus::before {
  opacity: 1;
}
.neon-button:hover::after,
.neon-button:focus::after {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./client/translatorCss/NeonButton.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;EACrB,sEAAsE;EACtE,0EAA0E;EAC1E,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAyD;EACzD,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,iCAAiC;EACjC,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ","sourcesContent":[":root {\r\n  --clr-neon: hsl(46, 100%, 50%);\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.neon-button {\r\n  font-size: 20px;\r\n  background-color: transparent;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  color: var(--clr-neon);\r\n  border: var(--clr-neon) 0.125em solid;\r\n  padding: 0.25em 1em;\r\n  border-radius: 0.25em;\r\n  text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;\r\n  box-shadow: inset 0 0 0.5em 0 var(--clr-neon), 0 0 0.5em 0 var(--clr-neon);\r\n  position: relative;\r\n  margin: 10px;\r\n  height: 50px;\r\n}\r\n\r\n.neon-button::before {\r\n  pointer-events: none;\r\n  content: '';\r\n  position: absolute;\r\n  background: var(--clr-neon);\r\n  top: 120%;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  transform: perspective(1em) rotateX(40deg) scale(1, 0.35);\r\n  filter: blur(1em);\r\n  opacity: 0.7;\r\n}\r\n\r\n.neon-button::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  box-shadow: 0 0 2em 0.5em var(--clr-neon);\r\n  opacity: 0;\r\n  background-color: var(--clr-neon);\r\n  z-index: -1;\r\n  transition: opacity 100ms linear;\r\n}\r\n\r\n.neon-button:hover,\r\n.neon-button:focus {\r\n  color: var(--clr-bg);\r\n  text-shadow: none;\r\n}\r\n\r\n.neon-button:hover::before,\r\n.neon-button:focus::before {\r\n  opacity: 1;\r\n}\r\n.neon-button:hover::after,\r\n.neon-button:focus::after {\r\n  opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
